import { render, staticRenderFns } from "./front-abroadorder.vue?vue&type=template&id=83917dd6"
import script from "./front-abroadorder.vue?vue&type=script&lang=ts"
export * from "./front-abroadorder.vue?vue&type=script&lang=ts"
import style0 from "./front-abroadorder.vue?vue&type=style&index=0&id=83917dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports